var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      






































































































pug_mixins["checkbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
if (!attributes.attributes) {
attributes.attributes = {}
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "checkbox schema-form-checkbox"},attributes.groupAttributes]), true)) + "\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([attributes.fieldHtmlClass], [true]),"type": "checkbox","ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"id": pug.escape(id),"name": pug.escape(id),"required": pug.escape(attributes.required),"ng-true-value": pug.escape(attributes['ng-true-value']),"ng-false-value": pug.escape(attributes['ng-false-value']),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};




















































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E\u003Cnav class=\"top-bar\" data-topbar=\"\" role=\"category-navigation\"\u003E\u003Csection class=\"top-bar-section\"\u003E\u003Cul ng-class=\"{active : mppBar.activeSearch}\"\u003E\u003Cli class=\"row search-box\"\u003E\u003Cdiv class=\"xsmall-2 columns\"\u003E\u003Clabel class=\"prefix\" for=\"search\"\u003E\u003Ci class=\"font-icon icon-search\"\u003E\u003C\u002Fi\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-10 columns\"\u003E\u003Cinput class=\"search-box__input\" id=\"search\" type=\"text\" placeholder=\"Artikelsuche...\" ng-model=\"mppBar.searchDialog\" ng-value=\"mppBar.searchDialog\" ng-change=\"mppBar.searchDelay()\" autofocus ng-focus=\"mppBar.activeSearch = true\" ng-blur=\"mppBar.activeSearch = false\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fsection\u003E\u003Csection class=\"top-bar-section left\"\u003E\u003Cul class=\"left\"\u003E\u003Cli class=\"has-dropdown not-click menu\"\u003E\u003Ca\u003E\u003Cspan\u003E{{selectedMainCategory}}\u003Ci class=\"font-icon icon-down account\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Cul class=\"dropdown scrollable\"\u003E\u003Cli ng-click=\"mppBar.selectMain(false)\"\u003E\u003Ca\u003EAlle\u003C\u002Fa\u003E\u003Cli ng-repeat=\"item in mppBar.mainCategories\" ng-click=\"mppBar.selectMain(item.name)\"\u003E\u003Ca\u003E{{ item.name }}\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fli\u003E\u003Cli class=\"has-dropdown not-click menu\" ng-show=\"selectedMainCategory != '' &amp;&amp; selectedMainCategory != 'Kategorien' &amp;&amp; selectedMainCategory != 'Alle'\"\u003E\u003Ca\u003E\u003Cspan\u003E{{selectedSubCategory}}\u003Ci class=\"font-icon icon-down account\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Cul class=\"dropdown scrollable\"\u003E\u003Cli ng-click=\"mppBar.selectSub(false)\"\u003E\u003Ca\u003EAlle\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli ng-repeat=\"item in mppBar.subCategories[selectedMainCategory].sub\" ng-click=\"mppBar.selectSub(item.name)\"\u003E\u003Ca\u003E{{ item.name }}\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fsection\u003E\u003Csection class=\"top-bar-section right\"\u003E\u003Cul class=\"left\"\u003E";
globals = {}   
pug_mixins["form"].call({
block: function(){
pug_mixins["checkbox"].call({
attributes: {"id": "show_only_supply_checkbox","key": "mppBar.filters.show_only_supply","title": "Verfügbares","attributes": {"ng-click":"mppBar.handleFilterChange()"}}
});
},
attributes: {"name": "show_only_supply_form"}
});
pug_html = pug_html + "\u003C\u002Ful\u003E \u003Cul class=\"left\"\u003E";
globals = {}   
pug_mixins["form"].call({
block: function(){
pug_mixins["checkbox"].call({
attributes: {"id": "show_only_mobile_checkbox","key": "mppBar.filters.show_only_mobile","title": "Smartphones","attributes": {"ng-click":"mppBar.handleFilterChange()"}}
});
},
attributes: {"name": "show_only_mobile_form"}
});
pug_html = pug_html + "\u003C\u002Ful\u003E \u003Cul class=\"left\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["checkbox"].call({
attributes: {"id": "show_only_main_checkbox","key": "mppBar.filters.show_only_main","title": "Hauptartikel","attributes": {"ng-click":"mppBar.handleFilterChange()"}}
});
},
attributes: {"name": "show_only_main_form"}
});
pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fsection\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"product-view\" ui-view=\"productsMain\"\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;